module.exports = __webpack_public_path__ + "img/top-dapps.07a40620.svg";